import Modal from "@mui/material/Modal";
import SignUpPage from "../SignUpP";
import SigninPage from "../SignInP";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { closeAuthModal } from "../../redux/slices/userSlice";
import { AuthActions } from "../Sidebar/constants";

const SignInModal = () => {
  const dispatch = useDispatch<AppDispatch>();

  const handleClose = (_, reason) => {
    if (authModal.disableClose && (reason === "backdropClick" || reason === "escapeKeyDown")) { // in some cases, don't allow user to close the modal
      return;
    }
    dispatch(closeAuthModal());
  };
  const { authModal } = useSelector((state: { user }) => state.user);

  return (
    <Modal
      open={authModal.isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="w-modal-sm md:w-modal-lg max-h-[90vh] overflow-y-auto bg-white dark:bg-background/paper-elevation-1 shadow rounded-lg outline-none"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {authModal.type === AuthActions.SIGNIN && <SigninPage />}
        {authModal.type === AuthActions.SIGNUP && <SignUpPage />}
      </Box>
    </Modal>
  );
};
export default SignInModal;
